import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useHistory } from "react-router";

import { ComponentHeaderAuth, ComponentSignUpOTP } from "@components";
import {
    addConfigClient,
    resetAuthState,
    selectConfigClient,
    selectMerchant,
    setAuth,
    setConfigClient,
    setFromLogin,
    setLoading,
} from "@redux";
import { enumExternalMethod, enumValidation, PATH_HOME, TIME_RESEND } from "@configs";
import { authApi } from "@api";
import { formatMessage, useNotify } from "@utils";
import { IAuthConfig } from "@interfaces";
import liff from "@line/liff";

export const PageLineTelOTP = () => {
    //page hook
    const history = useHistory();
    const { error, success } = useNotify();
    const dispatch = useDispatch();
    //page state
    const [otp, setOtp] = useState<string>("");
    const [timeResend, setTimeResend] = useState<number>(TIME_RESEND);
    //redux state
    // const { externalLogin } = useSelector(selectAuth);
    const configClient = useSelector(selectConfigClient);
    const { _id } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const signUpMethod = merchant?.signUpSettings?.signUpMethod;
    //page variable
    const phoneNumber = window.sessionStorage.getItem("phoneNumber") || "";
    const remember = window.sessionStorage.getItem("remember");
    const [checkSuccess, setCheckSuccess] = useState<boolean>(false);

    useEffect(() => {
        const unloadHandler = (event: Event) => {
            localStorage.clear();
            sessionStorage.clear();
            dispatch(resetAuthState());
        };

        window.addEventListener("unload", unloadHandler);
        if (liff.isInClient()) {
            liff._addListener("unload", unloadHandler);
        }

        return () => {
            window.removeEventListener("unload", unloadHandler);
            if (liff.isInClient()) {
                liff._removeListener("unload", unloadHandler);
            }
        };
    }, []);

    const isTechDomain = () => {
        const currentURL = window.location.href;
        return currentURL.includes(".app");
    };

    const handleChangeOtp = (newotp: string) => {
        setOtp(newotp);
        if (newotp.length === 6) {
            handleVerifyOtp(newotp);
        }
    };

    const handleVerifyOtp = async (outotp: string) => {
        if (outotp.length < enumValidation.LENTH_OTP) return;
        try {
            dispatch(setLoading(true));
            const res = await authApi.clientLinePhoneOtpVerify({
                phoneNumber,
                code: outotp,
            });
            const data = res.data.token as IAuthConfig;
            const message = res.data.message;

            const authData = remember
                ? { ...data, merchantId: _id || "" }
                : { ...data, refreshToken: null, merchantId: _id || "" };
            dispatch(setAuth(authData));
            if (_id) {
                const index = configClient.findIndex((item) => item.merchantId === _id);
                if (index >= 1) {
                    dispatch(
                        setConfigClient({
                            index,
                            configClient: {
                                merchantId: _id || "",
                                token: authData,
                            },
                        })
                    );
                } else {
                    dispatch(
                        addConfigClient({
                            merchantId: _id || "",
                            token: authData,
                        })
                    );
                }
                setCheckSuccess(true);
                success(message);

                if (
                    (merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINEOA_TEL ||
                        merchant?.signUpSettings?.signUpMethod === enumExternalMethod.LINE) &&
                    liff.isInClient() &&
                    message
                ) {
                    sessionStorage.setItem("SING_UP", "true");
                    history.push(PATH_HOME);
                } else {
                    history.push(PATH_HOME);
                }
                dispatch(setFromLogin(true));
            }
        } catch (errors: any) {
            // const { message } = errors.response.data;
            if (errors.response) {
                error(formatMessage(errors.response));
            }
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleResend = async () => {
        if (timeResend !== TIME_RESEND) return;
        try {
            dispatch(setLoading(true));
            const res = await authApi.clientResendLinePhone({
                phoneNumber,
            });
            if (res.data.message) {
                success(res.data.message);
                let currentTime = timeResend;
                const id = setInterval(() => {
                    currentTime = currentTime - 1;
                    setTimeResend(() => currentTime);
                    if (currentTime === 0) {
                        setTimeResend(TIME_RESEND);
                        clearInterval(id);
                    }
                }, 1000);
            }
        } catch (errors: any) {
            // const { message } = errors.response.data;
            if (errors.response) {
                error(formatMessage(errors.response));
            }
        } finally {
            dispatch(setLoading(false));
        }
    };

    return (
        <ComponentHeaderAuth>
            <ComponentSignUpOTP
                handleVerifyOtp={handleVerifyOtp}
                handleChangeOtp={handleChangeOtp}
                handleResend={handleResend}
                otp={otp}
                timeResend={timeResend}
            />
        </ComponentHeaderAuth>
    );
};
